/* eslint-disable */
export default {
  hide: 'Masquer',
  end: 'Raccrocher',
  keypad: 'Clavier téléphonique',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
